export default {
    search (params) {
        return window.axios.get('/api/service-reminders', {params});
    },

    update(reminder) {
        return window.axios.put(`/api/service-reminders/${reminder.id}`, reminder);
    },

    send(reminderIds) {
        return window.axios.post('/api/service-reminders/send', {reminder_ids: reminderIds});
    },
    
    updateStatuses(month, status) {
        return window.axios.put('/api/service-reminders/status', {month, status});
    },

    find(id) {
        return window.axios.get(`/api/service-reminders/${id}`);
    }
};


// WEBPACK FOOTER //
// ./resources/assets/js/services/ServiceReminderService.js